import { render, staticRenderFns } from "./Namespace.vue?vue&type=template&id=23e6dd46&"
import script from "./Namespace.vue?vue&type=script&lang=js&"
export * from "./Namespace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports